<template>
  <thead :data-testid="dataTestid">
    <tr :data-testid="`${dataTestid}-list-column`">
      <th
        v-if="allowSelection"
        class="sb-data-table__head-cell"
        :data-testid="`${dataTestid}-checkbox-cell`"
      >
        <SbCheckbox
          v-model="isActive"
          hide-label
          label="Select all rows"
          :indeterminate="isIndeterminate"
          :data-testid="`${dataTestid}-checkbox`"
        />
      </th>
      <SbDataTableHeaderCell
        v-for="(elem, index) in headers"
        :key="index"
        :column="elem"
        :sorted-key="sortedKey"
        :data-testid="`${dataTestid}-cell__${index}`"
        :is-sort-icon-always-visible="isSortIconAlwaysVisible"
        :index="index"
      />
    </tr>
  </thead>
</template>

<script lang="ts">
import SbCheckbox from '../../Checkbox'
import SbDataTableHeaderCell from './SbDataTableHeaderCell.vue'
import sharedProps from '../sharedProps'
import { useDataTable } from '../helpers'

export default {
  name: 'SbDataTableHeader',

  components: {
    SbCheckbox,
    SbDataTableHeaderCell,
  },

  inject: ['dataTableContext'],

  props: {
    allowSelection: sharedProps.allowSelection,
    headers: sharedProps.headers,
    selectedRows: sharedProps.selectedItems,
    sortedKey: {
      type: String,
      default: undefined,
    },
    allRowsSelected: {
      required: false,
      type: Boolean,
      default: true,
    },
    isSortIconAlwaysVisible: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const { context } = useDataTable()

    return {
      context,
    }
  },

  computed: {
    dataTestid() {
      return this.$attrs['data-testid'] || 'sb-data-table-header'
    },

    isIndeterminate() {
      return !this.allRowsSelected && !!this.selectedItemsLength
    },

    selectedItemsLength() {
      return this.selectedRows.length
    },

    isActive: {
      get() {
        return this.allRowsSelected
      },
      set() {
        this.handleAllRowsSelected()
      },
    },
  },

  methods: {
    handleAllRowsSelected() {
      this.allRowsSelected
        ? this.context.deselectAll()
        : this.context.selectAll()
    },
  },
}
</script>
